/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListRecommendationByAccountResponse {
    getFixupPrototypeFunction() { return ListRecommendationByAccountResponse.fixupPrototype; }

    static newInstance(model: Partial<ListRecommendationByAccountResponse>): ListRecommendationByAccountResponse {
        let obj = Object.assign(new ListRecommendationByAccountResponse(), model);
        ListRecommendationByAccountResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListRecommendationByAccountResponse>): ListRecommendationByAccountResponse {
        if (!model) return null;
        return ListRecommendationByAccountResponse.newInstance(<ListRecommendationByAccountResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListRecommendationByAccountResponse) {
        if (!obj) return;

        models.ListRecommendationByAccountResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListRecommendationByAccountResponse): boolean {
        Object.setPrototypeOf(obj, ListRecommendationByAccountResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.recommendations) {
            for (let val of this.recommendations) {
                models.RecommendationByAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * Page count
     */
    page_count: number;

    /**
     * Total count
     */
    total_count: number;

    /**
     * Recommendation Details
     */
    recommendations: Array<models.RecommendationByAccount>;

}
